import React from 'react';
import SEO from '../SEO/SEO';

const About = () => {
  return (
    <>
      <SEO
        title="About Us - SwiftToolsKit | Swift & SwiftUI Code Generator Tools"
        description="Learn about SwiftToolsKit - Free Swift and SwiftUI code generator tools for iOS developers. Our mission is to help developers save time and write better code."
        keywords="SwiftToolsKit about, iOS development tools, Swift code generator, about us"
        canonical="/about"
        image="/swifttoolskitlogo.png"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: 'About SwiftToolsKit',
            description: 'Learn about SwiftToolsKit - Free Swift and SwiftUI code generator tools for iOS developers.',
            url: typeof window !== 'undefined' ? `${window.location.origin}/about` : 'https://swift-tools-kit.com/about',
            publisher: {
              '@type': 'Organization',
              name: 'SwiftToolsKit',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: typeof window !== 'undefined' ? `${window.location.origin}/` : 'https://swift-tools-kit.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'About',
                item: typeof window !== 'undefined' ? `${window.location.origin}/about` : 'https://swift-tools-kit.com/about',
              },
            ],
          },
        ]}
        type="website"
      />
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="text-4xl font-bold mb-8">About SwiftToolsKit</h1>
          
          <div className="space-y-6 text-gray-700 dark:text-gray-300">
            <p className="text-lg">
              SwiftToolsKit is a comprehensive web-based platform designed to help iOS developers create Swift and SwiftUI code faster and more efficiently.
            </p>
            
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Our Mission</h2>
              <p>
                Our mission is to reduce iOS development time by 70-80% by providing free, easy-to-use tools that generate production-ready Swift code. We believe that developers should focus on building great apps, not writing boilerplate code.
              </p>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">What We Offer</h2>
              <p>
                SwiftToolsKit provides 10 powerful tools that cover everything from UI components to API integration:
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2 ml-4">
                <li>Loader Generator - Create animated loading indicators</li>
                <li>Gradient Generator - Design beautiful gradients</li>
                <li>Card Generator - Build reusable card components</li>
                <li>Animation Generator - Create smooth animations</li>
                <li>Alert Generator - Custom alert dialogs</li>
                <li>Photo Picker Generator - Camera & library integration</li>
                <li>JSON to Codable Generator - Convert JSON to Swift models</li>
                <li>API Generator - Generate API client code</li>
                <li>Storyboard Converter - UIKit to SwiftUI migration</li>
                <li>Postman Importer - Import Postman collections</li>
              </ul>
            </div>
            
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Why SwiftToolsKit?</h2>
              <p>
                All our tools feature real-time previews, comprehensive customization options, and generate copy-paste ready code that works directly in Xcode. No signup required, completely free, and always available.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;

